module.exports = __webpack_public_path__ + "static/media/albertsons.2241c487.svg";